<template>
  <b-card no-body class="mt-6" v-if="categorywisepages.data">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color "
      :data="categorywisepages.data"
      border
    >
      <el-table-column label="News" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.title }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Date" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{
              new Date(row.date).toLocaleDateString(undefined, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              })
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Edited By" prop="editedby" sortable>
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="row.isEdited"
          >
            {{
              row.editedBy.at(-1)._user.firstname +
                " " +
                row.editedBy.at(-1)._user.lastname || " "
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="40px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      Data,
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    ...mapState("cms", {
      categorywisepages: "categorywisepages",
      selectedpagecategory: "selectedpagecategory",
    }),
    displayedPages() {
     
    },
    totalPages() {
      return this.categorywisepages.data.length;
    },
  },
  methods: {
    handleView(slot) {
      const { row } = slot;
      this.$router.push({
        name: "blogspage",
        params: { id: row._id, slug: this.toKebabCase(row.title) },
      });
    },
    toKebabCase(string) {
      return string.toLowerCase().replace(/\s/g, "-");
    },
    toTitleCase(string) {
      return (
        string &&
        string.slice(0, 1).toUpperCase() + string.slice(1).toLowerCase()
      );
    },
    async handleEdit(scope) {
      let { row } = scope;
      await this.$store.commit("cms/SET_SELECTED_BLOG", row);

      this.$router.push({ name: "editNews" });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = row._id;
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("cms/deletePage", payload);
        loader.close();
        if (data.code === 200) {
          this.$swal({
            text: "News deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      let payload = {
        id: "61adf7f510718313e80bcc4c",
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
      this.$store.dispatch("cms/getpagebycategory",payload);
    },
  },
  async mounted() {
    this.$store.dispatch("cms/getpagebycategory", {
      id: "61adf7f510718313e80bcc4c",
    });
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
